import { bool, object } from 'prop-types';
import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { getBuyerId } from 'dibs-cookie-jar';
import LinkRow from './LinkRow/LinkRow';
import SocialLinkRow from './SocialLinkRow/SocialLinkRow';
import CurrencySelector from './CurrencySelector/CurrencySelector';
import CountrySelector from './CountrySelector/CountrySelector';
import AppStoreLinkLazy from './AppStoreLink/AppStoreLinkLazy';
import { primaryLinks, siteLinks, socialLinks, legalLinks, sitemapLinks, appLink } from './links';
import style from './Footer-style.scss';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isClient: false };
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState(prevState => {
            return { ...prevState, isClient: true };
        }, this.updateUserState);
    }

    componentDidUpdate(prevProps) {
        if (this.props.updateUserState && !prevProps.updateUserState) {
            this.updateUserState();
        }
    }

    updateUserState() {
        const userId = getBuyerId(document.cookie) || '';
        const hasUserId = !!userId;
        const refetchVariables = () => ({
            userId: userId,
            hasUserId,
        });

        this.props.relay.refetch(refetchVariables);
    }

    filterLinks(links) {
        return links.filter(link => {
            if (link.enablerKey && this.props.viewer[link.enablerKey] === false) {
                return null;
            }
            return link;
        });
    }

    render() {
        const { isClient } = this.state;
        const { viewer } = this.props;
        const { isSiteMapsEnabled, isDownloadAppEnabled } = viewer;

        return (
            <footer className={style.footer}>
                <LinkRow type="primary" items={this.filterLinks(primaryLinks)} viewer={viewer} />
                <div className={style.divider} />
                <LinkRow type="site" items={this.filterLinks(siteLinks)} viewer={viewer} />
                <SocialLinkRow items={socialLinks} isClient={isClient} />
                <LinkRow type="legal" items={this.filterLinks(legalLinks)} viewer={viewer} />

                <div className={style.row}>
                    <div className={style.cell}>
                        <div className={style.column}>
                            <CurrencySelector
                                isClient={isClient}
                                viewer={viewer}
                                user={viewer.user || null}
                            />
                            <CountrySelector isClient={isClient} />
                        </div>
                    </div>
                    {isDownloadAppEnabled && (
                        <div className={style.cell}>
                            <AppStoreLinkLazy link={appLink} isClient={isClient} />
                        </div>
                    )}
                </div>
                {isSiteMapsEnabled && (
                    <LinkRow type="sitemap" items={sitemapLinks} viewer={viewer} />
                )}
            </footer>
        );
    }
}

Footer.propTypes = {
    relay: object,
    updateUserState: bool,
    viewer: object,
};

const mapStateToProps = state => {
    const updateUserState = get(state, 'header.updateUserState');
    return { updateUserState };
};

export default createRefetchContainer(
    connect(mapStateToProps)(Footer),
    {
        viewer: graphql`
            fragment Footer_viewer on Viewer {
                isTradeExperienceEnabled: isEnabledByLocale(featureName: "TRADE_EXPERIENCE")
                isSellerDirectoryEnabled: isEnabledByLocale(featureName: "SELLER_DIRECTORY")
                isSellerApplicationEnabled: isEnabledByLocale(featureName: "SELLER_APPLICATION")
                isAboutUsPageEnabled: isEnabledByLocale(featureName: "ABOUT_US_PAGE")
                isCareersPageEnabled: isEnabledByLocale(featureName: "CAREERS_PAGE")
                isPressPageEnabled: isEnabledByLocale(featureName: "PRESS_PAGE")
                isQuestionsPageEnabled: isEnabledByLocale(featureName: "QUESTIONS_PAGE")
                isSiteMapsEnabled: isEnabledByLocale(featureName: "HTML_SITE_MAPS")
                isDownloadAppEnabled: isEnabledByLocale(featureName: "DOWNLOAD_APP")
                user(userId: $userId) @include(if: $hasUserId) {
                    serviceId
                    ...CurrencySelector_user
                }
                ...CurrencySelector_viewer
                ...LinkRow_viewer
            }
        `,
    },
    graphql`
        query FooterRefetchQuery($userId: String!, $hasUserId: Boolean!) {
            viewer {
                ...Footer_viewer
            }
        }
    `
);
